// Data: Language information
const languageInformation = {
	ar: {
		direction: 'rtl',
		name: 'Arabic',
		originalName: 'عربي'
	},
	en: {
		direction: 'ltr',
		name: 'English',
		originalName: 'English'
	},
	tr: {
		direction: 'ltr',
		name: 'Turkish',
		originalName: 'Türkçe'
	}
}

// Export
export default languageInformation
